// ##### Komarov 2025-07-26
import React from 'react';

// ##### Komarov 2025-09-02
const Image = ({
  first = false,
  src,
  shownImgRef,
  alt,
  style,
  onClick,
  onKeyUp,
  className,
  id,
}) => {
  return (
    <img
      fetchpriority={first ? 'high' : 'low'}
      src={src}
      ref={shownImgRef}
      alt={alt}
      style={style}
      className={className || null}
      onClick={onClick || null}
      onKeyUp={onKeyUp || null}
      id={id || null}
    />
  );
};

// ##### 25-05-02 Komarov
export default Image;
